var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-table',[_c('tbody',_vm._l((_vm.bizorder.items),function(item,index){return _c('AmountTableRow',{key:index,attrs:{"name":_vm.getName(item),"amount":item.price,"mandatory":""}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }